import React from "react";
import { Modal, Button } from "antd";
import { Translate } from "react-translated";

const DeleteModal = (props) => {
  const { hideModal, show_delete_modal, onDeleteOk, isDeleting } = props;



  return (
    <Modal
      title={<Translate text={`Delete B File`} />}

      onCancel={hideModal}
      visible={show_delete_modal}
      footer={
        <React.Fragment>
          <Button
            className="borderRadius-28"
            onClick={hideModal}>
            <Translate text={`Cancel`} />
          </Button>
          <Button className="btn-bg-164897 borderRadius-28"
            onClick={onDeleteOk}
            disabled={isDeleting} 
            loading={isDeleting}  
          >
            <Translate text={`Submit`} />
          </Button>
        </React.Fragment>
      }
    >
      <Translate text={`Are you sure you want to delete this B File?`} />
    </Modal>
  );
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/DeleteModal.js